/**
 * @generated SignedSource<<407e18d01feaa184db4e9776f47e84e3>>
 * @relayHash f1f6274b2752eb7f782581ae11d3b43d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c3c716f0215952ef99d253a24485c8deaf08ed910bf26cabf38298272874c7c8

import type { ConcreteRequest } from 'relay-runtime';
export type JpdViewsServiceCloneViewIntoGlobalInput = {
  id: string;
};
export type useCloneViewIntoGlobalMutation$variables = {
  input: JpdViewsServiceCloneViewIntoGlobalInput;
};
export type useCloneViewIntoGlobalMutation$data = {
  readonly jpdViewsService_cloneViewIntoGlobal: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null;
    }> | null;
    readonly node: {
      readonly id: string;
    } | null;
    readonly success: boolean;
  } | null;
};
export type useCloneViewIntoGlobalMutation = {
  response: useCloneViewIntoGlobalMutation$data;
  variables: useCloneViewIntoGlobalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "JpdViewsServiceCreateGlobalViewPayload2",
    "kind": "LinkedField",
    "name": "jpdViewsService_cloneViewIntoGlobal",
    "plural": false,
    "selections": [
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "JpdViewsServiceGlobalView2",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCloneViewIntoGlobalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCloneViewIntoGlobalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "c3c716f0215952ef99d253a24485c8deaf08ed910bf26cabf38298272874c7c8",
    "metadata": {},
    "name": "useCloneViewIntoGlobalMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e860d9d439dda8eb121e8833ee8d2f89";

export default node;
